<template>
  <b-row
    class="d-flex flex-row align-items-start justify-content-start"
    no-gutters
  >
    <b-col class="d-flex flex-column align-items-start justify-content-start">
      <!-- Add a New FAQ form -->
      <h6
        class="text-left text-dark font-weight-semi-bold font-primary mb-3 mt-3"
      >
        Terms
      </h6>
      <form
        id="admin-registration-form"
        class="d-flex flex-column align-items-start justify-content-start w-100"
      >
        <b-row
          class="
            d-flex
            flex-row
            align-items-start
            justify-content-start
            w-100
            py-2
          "
          no-gutters
        >
          <b-col cols="12">
            <!-- text editor -->
            <vue-editor
              class="editor mb-4"
              v-model="termsText"
              :editor-toolbar="customToolbar"
            >
            </vue-editor>
          </b-col>
        </b-row>
        <!-- form action -->
        <b-row
          v-if="saveTermsError.status"
          class="
            d-flex
            flex-row
            align-items-center
            justify-content-center
            w-100
          "
          no-gutters
        >
          <!-- error message span class -->
          <b-col
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              px-0
              py-2
            "
            cols="9"
          >
            <span class="text-danger text-center" style="font-size: 0.8rem">{{
              saveTermsError.message
            }}</span>
          </b-col>
        </b-row>
        <b-row
          class="
            d-flex
            flex-row
            align-items-center
            justify-content-center
            w-100
          "
          no-gutters
        >
          <b-col
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              px-0
              py-2
            "
            cols="6"
          >
            <FormButton
              variant="primary"
              isBlock
              class="font-weight-normal text-white mt-4 border-dark"
              type="submit"
              @click.native="saveData"
              :isLoading="isAPILoading"
              :isDisabled="isAPILoading"
            >
              Save Changes
            </FormButton>
          </b-col>
        </b-row>
      </form>
    </b-col>
    <!-- overlay loader -->
    <b-overlay :show="initLoading" class="mx-n3" no-wrap></b-overlay>
  </b-row>
</template>

<script>
// components
import FormButton from "@/components/Form/FormButton";

// services
import { SaveTerms, GetTerms } from "@/services/content.service";

export default {
  name: "TermsandCondition",
  components: {
    FormButton,
  },
  created() {
    this.onInit();
  },
  data() {
    return {
      initLoading: false,
      isAPILoading: false,
      termsText: null,
      termsTextError: {
        status: null,
        message: null,
      },
      saveTermsError: {
        status: null,
        message: null,
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link"],
      ],
    };
  },
  watch: {
    termsText(val) {
      this.termsTextError.status = false;
      this.errorFn(val);
    },
  },
  methods: {
    closeModal() {
      this.$emit("onClose");
    },
    async onInit() {
      try {
        this.initLoading = true;
        var { data } = await GetTerms();

        if (data.code == 200 && data.message == "success") {
          if (data.content) this.termsText = data.content.terms;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.initLoading = false;
      }
    },
    async saveData() {
      try {
        this.isAPILoading = true;
        var errors = this.errorFn();
        if (errors.length == 0) {
          let payload = {
            terms: this.termsText,
          };
          let { data } = await SaveTerms(payload);

          if (data && data.code == 200 && data.message == "success") {
            let payloadNotify = {
              isToast: true,
              title: "T&C Content",
              content: "T&C Content was saved successfully",
              variant: "success",
            };
            this.$store.dispatch("notification/setNotify", payloadNotify);
            this.$emit("reloadFn");
          } else if (data) {
            this.saveTermsError.status = true;
            this.saveTermsError.message = `An error occured when saving the T&C Content: ${data.details}`;
            this.handleErrorFn("T&C Content was not saved", [
              data.details,
              data.errorCode,
            ]);
          } else throw new Error("Error saving details");
        } else {
          this.handleErrorFn(
            "It seems like you have missed some important fields when saving the T&C Content",
            errors
          );
        }
      } catch (error) {
        this.saveTermsError.status = true;
        this.saveTermsError.message = `An error occured when saving T&C Content: ${error.message}`;
        this.handleErrorFn("T&C Content was not saved", [error.message]);
      } finally {
        this.isAPILoading = false;
      }
    },
    handleErrorFn(content, list) {
      var payloadNotify = {
        isToast: true,
        title: "ERROR! T&C Content",
        content,
        list,
        variant: "danger",
      };
      this.$store.dispatch("notification/setNotify", payloadNotify);
    },
    errorFn(termsText = this.termsText) {
      var termsTextError = this.validateTermsText(termsText);
      if (termsTextError.length > 0) {
        this.termsTextError.status = false;
        this.termsTextError.message = termsTextError[0];
      } else this.termsTextError.status = true;
      return [...termsTextError];
    },
    validateTermsText(val) {
      var errorList = [];
      if (!val) errorList.push("Please fill in the T&C text");
      return errorList;
    },
  },
};
</script>
<style scoped>
.editor {
  height: 750px;
  max-height: calc(100vh - 120px);
}
.editor >>> .ql-tooltip {
  z-index: 50;
}
</style>